<template>
    <section style="height:100%">
        <el-row>
            <el-col :span="4" style="height:100%" v-bind:style="{height: menuHeight}">
                <el-menu :default-active="activedIndex" :default-openeds="['1-1','1-2', '1-3', '1-4']" style="height:100%;border-radius: 0 !important" theme="dark" :router="true">
                    <el-submenu index="1-1">
                        <template slot="title">账号管理</template>
                        <el-menu-item index="/settings/company">企业管理</el-menu-item>
                        <el-menu-item v-if="me.rname === 'ROLE_ADMIN'" index="/settings/user">用户管理</el-menu-item>
                    </el-submenu>
                    <el-submenu index="1-2">
                        <template slot="title">采集平台管理</template>
                        <!--<el-menu-item index="/settings/dtu">DTU管理</el-menu-item>-->
                        <el-menu-item index="/settings/device">设备管理</el-menu-item>
                        <!--<el-menu-item index="/settings/params">参数设置</el-menu-item>-->
                    </el-submenu>
                    <el-submenu index="1-3">
                        <template slot="title">能效管理</template>
                        <el-menu-item index="/settings/energy-level">阶梯时间管理</el-menu-item>
                        <el-menu-item index="/settings/energy-price">费率管理</el-menu-item>
                    </el-submenu>
                    <el-submenu index="1-4">
                        <template slot="title">其他管理</template>
                        <el-menu-item index="/settings/city">城市管理</el-menu-item>
                        <el-menu-item index="/settings/notice">通知管理</el-menu-item>
                        <el-menu-item index="/settings/device-status">离线统计</el-menu-item>
                        <el-menu-item index="/settings/service-log">服务记录</el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-col>
            <el-col :span="20" style="height:100%;padding:20px;">
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </el-col>
        </el-row>
    </section>

</template>
<style>
</style>
<script>
    export default{
        data() {
            return {
              me: JSON.parse(sessionStorage.getItem('user')),
              activedIndex: '/settings/company',
              menuHeight: (window.innerHeight - 60) + 'px',
            }
        },
        mounted() {
            this.activedIndex =  this.$route.path;
        }
    }
</script>



// WEBPACK FOOTER //
// SettingsLayout.vue?5cc54d81